// features/auth/authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  ADMIN_PERMISSIONS,
  STUDENT_PERMISSIONS,
  TRAINER_PERMISSIONS,
} from "../services/userOption";

const initialState = {
  user: null,
  isLoggedIn: false,
  statistics:null,
  statisticsComponent:{
    data:[],
    dataObj:{},
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    changeActiveUrl(state, action) {
      state.activeurl = action.payload;
    },
    changeActiveRoute(state, action) {
      state.activeRoute = action.payload;
    },
    login(state, action) {
      const user = action.payload;
      // console.log(user);
      state.user = user;
      state.isLoggedIn = true;

      switch (user.type) {
        case "ADMIN":
          state.userOptions = ADMIN_PERMISSIONS;
          break;
        case "STUDENT":
          state.userOptions = STUDENT_PERMISSIONS;
          break;
        default:
          state.userOptions = TRAINER_PERMISSIONS;
      }
    },
    logout(state) {
      state.user = {};
      state.isLoggedIn = false;
    },
    setStatistics(state, action) {
      state.statistics = action.payload;
    },
    setStatisticsComponent(state, action) {
      const {payload,payload1} = action.payload
      state.statisticsComponent={
        data:payload,
        dataObj:payload1,
      }
  },
},
});

export const {
  changeActiveUrl,
  changeActiveRoute,
  login,
  logout,
  setStatistics,
  setStatisticsComponent,
} = authSlice.actions;

export default authSlice.reducer;
